"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var hooks_1 = require("material-ui-popup-state/hooks");
var core_1 = require("@material-ui/core");
var ExpandMoreRounded_1 = __importDefault(require("@material-ui/icons/ExpandMoreRounded"));
var Button_1 = __importDefault(require("../../Button"));
var constants_1 = require("../constants");
exports.useStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        root: {},
    });
});
var DeckTabsDropdownMenu = function (_a) {
    var activeTab = _a.activeTab, classNameProp = _a.className, menuItems = _a.menuItems, _b = _a.useActiveTabAsLabel, useActiveTabAsLabel = _b === void 0 ? false : _b, onSelectTab = _a.onSelectTab, other = __rest(_a, ["activeTab", "className", "menuItems", "useActiveTabAsLabel", "onSelectTab"]);
    var popupState = hooks_1.usePopupState({
        variant: 'popover',
        popupId: 'deck-tabs-dropdown-menu-popup',
    });
    var classes = exports.useStyles();
    var createMenuItemClickHandler = react_1.useCallback(function (value) {
        return function (event) {
            popupState.close();
            onSelectTab(event, value);
        };
    }, [popupState, onSelectTab]);
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.root, classNameProp) }, other),
        react_1.default.createElement(Button_1.default, __assign({ variant: "text", size: "large" }, hooks_1.bindTrigger(popupState)),
            !useActiveTabAsLabel ? 'More' : constants_1.tabNames[activeTab],
            " ",
            react_1.default.createElement(ExpandMoreRounded_1.default, null)),
        react_1.default.createElement(core_1.Menu, __assign({}, hooks_1.bindMenu(popupState)), menuItems.map(function (item) { return (react_1.default.createElement(core_1.MenuItem, { key: item, onClick: createMenuItemClickHandler(item) }, constants_1.tabNames[item])); }))));
};
exports.default = DeckTabsDropdownMenu;
//# sourceMappingURL=DeckTabsDropdownMenu.js.map